__turbopack_context__.v({
  "h1": "styleConstants-module__MPwxPG__h1",
  "h1Opt": "styleConstants-module__MPwxPG__h1Opt",
  "h2": "styleConstants-module__MPwxPG__h2",
  "h2Large": "styleConstants-module__MPwxPG__h2Large",
  "h2Opt": "styleConstants-module__MPwxPG__h2Opt",
  "h2Small": "styleConstants-module__MPwxPG__h2Small",
  "h3": "styleConstants-module__MPwxPG__h3",
  "larger": "styleConstants-module__MPwxPG__larger",
  "leftSideTextWrapper": "styleConstants-module__MPwxPG__leftSideTextWrapper",
  "p": "styleConstants-module__MPwxPG__p",
  "pBody": "styleConstants-module__MPwxPG__pBody",
  "pLarge": "styleConstants-module__MPwxPG__pLarge",
  "pLargeGradient": "styleConstants-module__MPwxPG__pLargeGradient",
  "pOpt": "styleConstants-module__MPwxPG__pOpt",
});
